// =============================================================================
// READ CAPTURE DATE (EXIF DateTimeOriginal)
// =============================================================================
// Reads a photo's capture date from its EXIF metadata in the browser, before
// client-side compression re-encodes the file and strips that metadata. The
// value is sent alongside the upload so the gallery files the photo under when
// it was taken rather than when it was uploaded.

import exifr from 'exifr';

// Best-effort: returns the ISO capture date, or null when the file carries no
// usable EXIF date (screenshots, edited exports) or cannot be parsed.
export async function readCaptureDate(file: File): Promise<string | null> {
  if (!file.type.startsWith('image/')) {
    return null;
  }
  try {
    const exif = await exifr.parse(file, ['DateTimeOriginal', 'CreateDate']);
    const taken: unknown = exif?.DateTimeOriginal ?? exif?.CreateDate;
    if (taken instanceof Date && !Number.isNaN(taken.getTime())) {
      return taken.toISOString();
    }
    return null;
  } catch {
    return null;
  }
}
